// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"518":"01a1f10d","938":"2d45453b"}[chunkId] + ".chunk.css";
};